import { getCookie } from 'cookies-next'
import { useRouter } from 'next/router'
import { useMemo } from 'react'

const ForwarderPage = () => {
  const { query } = useRouter()
  const appLogin = useMemo(() => getCookie('forwarderSession'), [])

  window.localStorage.setItem('app-login', `${appLogin}`)

  if (query.target) window.location.replace(`${query.target}`)

  return null
}

export default ForwarderPage
